import { Component, inject, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { ButtonModule, IconModule } from '@pinup-teams/common';
import { TranslateModule } from '@ngx-translate/core';

import { ChatMessageReaction } from '../../../../models';
import { AiCharStore } from '../../store';
import { TranslateInPipe } from '../../../../pipes/translate-in.pipe';

@Component({
  standalone: true,
  selector: 'message-reaction',
  templateUrl: 'message-reaction.component.html',
  styleUrl: 'message-reaction.component.scss',
  imports: [
    NgTemplateOutlet,
    ButtonModule,
    IconModule,
    TranslateModule,
    NgClass,
    TranslateInPipe,
  ],
})
export class MessageReactionComponent {
  #aiChatStore = inject(AiCharStore);

  messageId = input.required<string>();
  reaction = input<ChatMessageReaction>();
  feedbackProvided = input<boolean>();

  chatMessageReaction = ChatMessageReaction;

  openFeedbackForm() {
    this.#aiChatStore.openFeedbackForm(this.messageId());
  }

  toggleReaction(reaction: ChatMessageReaction) {
    this.#aiChatStore.toggleReaction({
      id: this.messageId(),
      reaction:
        this.reaction() === reaction ? ChatMessageReaction.none : reaction,
    });
  }
}
